import urlJoin from "url-join";
import { httpPostSimple } from "./makeRequest.js";
export async function requestEdgeCityBalances(zupassServerUrl) {
    return httpPostSimple(urlJoin(zupassServerUrl, "/edgecity/balances"), async (resText) => ({
        value: JSON.parse(resText),
        success: true
    }));
}
